<div class="p-5">
  @if(device) {
    @if(isSaving) {
      <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
        <app-loader [message]="'Procesando'"></app-loader>
      </div>
    }

    <!-- Historic dialog -->
    <p-dialog header="Histórico de consumos" [(visible)]="showHistoric" [modal]="true" [style]="{width: '700px'}" [dismissableMask]="true">
      @if(historicData) {
        <div class="grid grid-cols-2 gap-4">
          <div class="bg-vivid-royal-50 dark:bg-crayola-blue-800 rounded-xl p-4">
            <h4 class="text-sm font-semibold text-vivid-royal-500 dark:text-vivid-royal-200 dark:text-vivid-royal-200 mb-3">Litros</h4>
            <div class="space-y-3">
              <div class="flex justify-between"><span class="text-sm text-vivid-royal-400">Diario</span><span class="font-semibold text-vivid-royal-700 dark:text-white">{{ historicData.daily.quantity | number:'1.2-3' }} L</span></div>
              <div class="flex justify-between"><span class="text-sm text-vivid-royal-400">Semanal</span><span class="font-semibold text-vivid-royal-700 dark:text-white">{{ historicData.weekly.quantity | number:'1.2-3' }} L</span></div>
              <div class="flex justify-between"><span class="text-sm text-vivid-royal-400">Mensual</span><span class="font-semibold text-vivid-royal-700 dark:text-white">{{ historicData.monthly.quantity | number:'1.2-3' }} L</span></div>
            </div>
          </div>
          <div class="bg-vivid-royal-50 dark:bg-crayola-blue-800 rounded-xl p-4">
            <h4 class="text-sm font-semibold text-vivid-royal-500 dark:text-vivid-royal-200 dark:text-vivid-royal-200 mb-3">Monto</h4>
            <div class="space-y-3">
              <div class="flex justify-between"><span class="text-sm text-vivid-royal-400">Diario</span><span class="font-semibold text-vivid-royal-700 dark:text-white">{{ historicData.daily.amount | currency }}</span></div>
              <div class="flex justify-between"><span class="text-sm text-vivid-royal-400">Semanal</span><span class="font-semibold text-vivid-royal-700 dark:text-white">{{ historicData.weekly.amount | currency }}</span></div>
              <div class="flex justify-between"><span class="text-sm text-vivid-royal-400">Mensual</span><span class="font-semibold text-vivid-royal-700 dark:text-white">{{ historicData.monthly.amount | currency }}</span></div>
            </div>
          </div>
        </div>
        @if(historicData.daily.loads !== undefined) {
          <div class="mt-4 text-center text-sm text-vivid-royal-400">Cargas en el día: <span class="font-bold text-vivid-royal-700 dark:text-white">{{ historicData.daily.loads }}</span></div>
        }
      }
    </p-dialog>

    <div class="max-w-5xl mx-auto space-y-5 mt-3">
      <button pButton label="Regresar" icon="pi pi-arrow-left" class="p-button-text p-button-sm" (click)="backButton()"></button>

      <!-- Header -->
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 flex flex-wrap items-center justify-between gap-4">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-xl bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center">
            <i class="pi pi-credit-card text-xl text-vivid-royal-500 dark:text-vivid-royal-300"></i>
          </div>
          <div>
            <h1 class="text-lg font-bold text-vivid-royal-800 dark:text-white">{{ device!.vehicleFullNumber || device!.number }}</h1>
            <p class="text-sm text-vivid-royal-400">{{ device!.nameUser }} · {{ device!.plates }}</p>
          </div>
          <span class="px-2.5 py-1 rounded-full text-xs font-semibold"
            [ngClass]="device!.cardStatus === 'A' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">
            {{ device!.cardStatus === 'A' ? 'Activo' : 'Inactivo' }}
          </span>
        </div>
        <button pButton label="Ver histórico" icon="pi pi-chart-bar" class="p-button-sm p-button-outlined" (click)="loadHistoric()"></button>
      </div>

      <!-- Tabs -->
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm overflow-hidden">
        <p-tabView [scrollable]="true">
          <p-tabPanel header="Tarjeta" leftIcon="pi pi-credit-card">
            <div class="p-4">
              <app-card-data-form [device]="device" (onSaving)="showSavingModal($event)" (onResponse)="showResponseModal($event)"></app-card-data-form>
            </div>
          </p-tabPanel>
          @if(isAdmin) {
            <p-tabPanel header="NIP" leftIcon="pi pi-lock">
              <div class="p-4">
                <app-nip-form [device]="device" (onSaving)="showSavingModal($event)" (onResponse)="showResponseModal($event)"></app-nip-form>
              </div>
            </p-tabPanel>
          }
          <p-tabPanel header="Unidad" leftIcon="pi pi-car">
            <div class="p-4">
              <app-device-data-form [device]="device" (onSaving)="showSavingModal($event)" (onResponse)="showResponseModal($event)"></app-device-data-form>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Parámetros" leftIcon="pi pi-sliders-h">
            <div class="p-4">
              <app-fuel-params-form [device]="device" (onSaving)="showSavingModal($event)" (onResponse)="showResponseModal($event)"></app-fuel-params-form>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Foto Carga" leftIcon="pi pi-camera">
            <div class="p-4">
              <app-photo-params-form [device]="device" (onSaving)="showSavingModal($event)" (onResponse)="showResponseModal($event)"></app-photo-params-form>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Horarios" leftIcon="pi pi-clock">
            <div class="p-4">
              <app-device-schedule-form [device]="device" (onSaving)="showSavingModal($event)" (onResponse)="showResponseModal($event)"></app-device-schedule-form>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  } @else {
    <!-- Skeleton mientras carga -->
    <div class="max-w-5xl mx-auto space-y-5 mt-3 animate-pulse">
      <p-skeleton width="6rem" height="2rem" />

      <!-- Header skeleton -->
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 flex items-center gap-4">
        <p-skeleton shape="circle" size="3rem" />
        <div class="flex-1 space-y-2">
          <p-skeleton width="12rem" height="1.25rem" />
          <p-skeleton width="8rem" height="0.875rem" />
        </div>
        <p-skeleton width="5rem" height="1.5rem" borderRadius="9999px" />
      </div>

      <!-- Tabs skeleton -->
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 space-y-5">
        <div class="flex gap-4 border-b border-dark-khaki-200 dark:border-vivid-royal-700 pb-3">
          <p-skeleton width="5rem" height="1.5rem" />
          <p-skeleton width="4rem" height="1.5rem" />
          <p-skeleton width="5rem" height="1.5rem" />
          <p-skeleton width="6rem" height="1.5rem" />
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          @for(i of [1,2,3,4,5,6]; track i) {
            <div class="space-y-2">
              <p-skeleton width="6rem" height="0.75rem" />
              <p-skeleton width="100%" height="2.5rem" />
            </div>
          }
        </div>
        <div class="flex justify-end">
          <p-skeleton width="7rem" height="2.25rem" />
        </div>
      </div>
    </div>
  }
</div>
